// extracted by mini-css-extract-plugin
export default {"item":"item---PJ1Oy","content":"content---xpLni","creationLabel":"creationLabel---OjkGN"};